interface SummaryCardsProps {
  pending: number;
  warnings: number;
  approved: number;
  missing: number;
}

interface CardProps {
  label: string;
  count: number;
  modifier: string;
}

function Card({ label, count, modifier }: CardProps) {
  return (
    <div className={`summary-card summary-card--${modifier}`}>
      <span className="summary-card__count" aria-label={`${count} ${label}`}>
        {count}
      </span>
      <span className="summary-card__label">{label}</span>
    </div>
  );
}

export function SummaryCards({ pending, warnings, approved, missing }: SummaryCardsProps) {
  return (
    <div className="summary-cards" role="region" aria-label="Approval summary">
      <Card label="Pending" count={pending} modifier="pending" />
      <Card label="Warnings" count={warnings} modifier="warnings" />
      <Card label="Approved" count={approved} modifier="approved" />
      <Card label="Missing" count={missing} modifier="missing" />
    </div>
  );
}
